var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, PropertyConverters, P } from '@pacem/pacem-core';
import { ShapeElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
//namespace Pacem.Components.Drawing {
let PacemPathElement = class PacemPathElement extends ShapeElement {
    constructor() {
        super(...arguments);
        this.getPathData = () => this.d;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'd' && !first) {
            this.recomputeShape();
        }
    }
    getShapeGeometry() {
        return { pathData: this.getPathData(), /* TODO: parse d */ boundingRect: null, vertices: [] };
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemPathElement.prototype, "d", void 0);
PacemPathElement = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-path' })
], PacemPathElement);
export { PacemPathElement };
